import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-quantity-order-class-location',
  templateUrl: './quantity-order-class-location.component.html',
  styleUrls: ['./quantity-order-class-location.component.css'],
})
export class QuantityOrderClassLocationComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  message: string = '';

  constructor(private api: ApiService) {}
  dataSource: any = {
    chart: {
      theme: 'fusion',
      paletteColors: '#7B68EE',
      maxBarHeight: '14',
      showValues: '1',
      baseFontSize: '13',
    },
    data: [],
  };
  loading: boolean = true;
  errorApi: boolean = false;
  typeClassificationLocation: string = '';
  @Output() errorEmitter = new EventEmitter();

  ngOnInit(): void {
    this.typeClassificationLocation = '';
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    this.getOrderClassLocation(item);
  }

  async getOrderClassLocation(item: any) {
    if (!this.validateFilter(item)) return;

    this.typeClassificationLocation = '';
    this.typeClassificationLocation =
      '- ' + item.typeClassificationLocationDescription;
    try {
      this.dataSource.data = [];
      const result = await this.api
        .getQuantityOrderClassLocation(
          item.typeClassificationLocation,
          item.branch
        )
        .toPromise();
      if (result.items.length != 0) {
        result.items.sort(
          (a: any, b: any) => b.normalQuantity - a.normalQuantity
        );
        result.items.map((el: any) => {
          this.dataSource.data.push({
            label: el.classificationDescription,
            value: el.normalQuantity,
          });
        });
        this.errorApi = false;
      } else {
        this.message = CONSTANTS.MESSAGES.DATA_NULL_LOCATIONQUANTITY;
        this.errorApi = true;
      }
    } catch (error) {
      this.loading = false;
      this.errorApi = true;
      this.formatErrorMensagem(error.error[0].message);
    } finally {
      if (this.dataSource.data == '') {
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_NULL_LOCATIONQUANTITY;
        this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_LOCATIONQUANTITY);
      }
      this.loading = false;
    }
  }

  validateFilter(item: any): boolean {
    if (item.typeClassificationLocation.length === 0) {
      this.message = CONSTANTS.MESSAGES.DATA_CLASSLOCATION_NULL;
      this.loading = false;
      this.errorApi = true;
      return false;
    }
    if (item.branch == '') {
      this.message = CONSTANTS.MESSAGES.DATA_BRANCH_NULL;
      this.loading = false;
      this.errorApi = true;
      return false;
    }

    return true;
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: quantity-location-normal \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
